import { useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { X } from "lucide-react";

interface ImageModalProps {
  src: string;
  alt: string;
  className?: string;
  containerClassName?: string;
}

export const ImageModal = ({ src, alt, className, containerClassName }: ImageModalProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div 
        className={`cursor-pointer hover:opacity-90 transition-opacity ${containerClassName || ''}`}
        onClick={() => setOpen(true)}
        onDragStart={(e) => { e.preventDefault(); e.stopPropagation(); }}
      >
        <img src={src} alt={alt} className={className} draggable={false} />
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="image-modal-overlay max-w-[95vw] max-h-[95vh] p-0 bg-black border-0">
          <button
            onClick={() => setOpen(false)}
            className="absolute top-4 right-4 z-50 bg-white/10 hover:bg-white/20 rounded-full p-2 transition-colors"
            aria-label="Close"
          >
            <X className="w-6 h-6 text-white" />
          </button>
          <div className="flex flex-col items-center w-full h-full p-8 overflow-auto">
            <div className="flex-1 flex items-center justify-center min-h-0">
              <img 
                src={src} 
                alt={alt} 
                className="max-w-full max-h-full object-contain"
                draggable={false}
              />
            </div>
            {alt && (
              <p className="text-white text-center mt-6 text-lg flex-shrink-0">{alt}</p>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
